import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tomos = [{
  num: '1',
  icon: '📘',
  name: 'El Diagnóstico Crítico',
  desc: 'Por qué tu CV no funciona y qué cambiar primero'
}, {
  num: '2',
  icon: '📗',
  name: 'Ingeniería Anti-ATS',
  desc: 'Cómo pasar los filtros automáticos y aparecer en el ranking'
}, {
  num: '3',
  icon: '📙',
  name: 'El Perfil de Alto Impacto',
  desc: 'El título y el resumen que generan deseo de conocerte'
}, {
  num: '4',
  icon: '📕',
  name: 'Experiencia Ganadora',
  desc: 'Transformar funciones en logros con números reales'
}, {
  num: '5',
  icon: '📓',
  name: 'La Carta de Asalto',
  desc: 'El mail y el mensaje que hacen abrir tu CV'
}, {
  num: '6',
  icon: '📔',
  name: 'El Kit de Edición Final',
  desc: '15 plantillas listas para completar y enviar hoy'
}];
const features = ['Sistema paso a paso', 'Plantillas listas', 'Ejemplos antes/después', 'Checklists de verificación', 'Estrategias para el mercado argentino'];
export function ProductBreakdown() {
  return <section className="py-24 px-4 bg-[#112240]/30 border-t border-slate-800/50" data-id="element-209">
      <div className="max-w-5xl mx-auto" data-id="element-210">
        <div className="text-center mb-16" data-id="element-211">
          <h2 className="md:text-5xl font-bold text-white mb-6 flex items-center justify-center gap-3 flex-wrap text-[26px]" data-id="element-212">
            <span data-id="element-213">🏆</span> MEGAPACK EMPLEO
          </h2>
          <p className="text-[#d4a843] font-semibold text-[18px]" data-id="element-214">
            6 Tomos + 6 Bonos — Todo resuelto
          </p>
        </div>

        <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-2" data-id="element-215">
          📚 LOS 6 TOMOS
        </h3>

        <div className="bg-[#0a1628] rounded-2xl border border-slate-700 overflow-hidden shadow-xl mb-12" data-id="element-216">
          <div className="overflow-x-auto hide-scrollbar" data-id="element-217">
            <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-218">
              <thead data-id="element-219">
                <tr className="bg-[#112240] border-b border-slate-700" data-id="element-220">
                  <th className="py-4 px-6 text-slate-300 font-semibold w-24" data-id="element-221">
                    Tomo
                  </th>
                  <th className="py-4 px-6 text-slate-300 font-semibold w-1/3" data-id="element-222">
                    Nombre
                  </th>
                  <th className="py-4 px-6 text-slate-300 font-semibold" data-id="element-223">
                    Lo que resuelve
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-224">
                {tomos.map((tomo, i) => <motion.tr initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.05
              }} key={i} className="border-b border-slate-800/50 hover:bg-[#112240]/50 transition-colors" data-id="element-225">
                    <td className="py-5 px-6 font-bold text-lg text-slate-400" data-id="element-226">
                      {tomo.icon} {tomo.num}
                    </td>
                    <td className="py-5 px-6 font-bold text-white" data-id="element-227">
                      {tomo.name}
                    </td>
                    <td className="py-5 px-6 text-slate-300" data-id="element-228">{tomo.desc}</td>
                  </motion.tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-[#112240] rounded-xl p-6 border border-[#d4a843]/20" data-id="element-229">
          <p className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-4 text-center" data-id="element-230">
            Cada tomo incluye:
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-231">
            {features.map((feat, i) => <div key={i} className="flex items-center gap-2 text-sm md:text-base text-slate-200" data-id="element-232">
                <div className="bg-green-500/20 p-0.5 rounded-full" data-id="element-233">
                  <Check className="w-4 h-4 text-green-400" data-id="element-234" />
                </div>
                {feat}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}